var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
export const Grid = (_a) => {
    var { children, className, container, col, xs, md, lg, xl } = _a, props = __rest(_a, ["children", "className", "container", "col", "xs", "md", "lg", "xl"]);
    return (_jsx("div", Object.assign({ className: [
            ...(container
                ? ['o-grid']
                : [
                    col ? `o-grid-${col}` : 'o-grid-12',
                    xs ? `o-grid-${xs}@xs` : '',
                    md ? `o-grid-${md}@md` : '',
                    lg ? `o-grid-${lg}@lg` : '',
                    xl ? `o-grid-${xl}@xl` : '',
                ]),
            className !== null && className !== void 0 ? className : '',
        ]
            .filter((s) => s && s.length > 0)
            .join(' ') }, props, { children: children !== null && children !== void 0 ? children : null })));
};
export default Grid;
